import type { VoceMenu } from "@/types";

/** Dopo l'accesso l'operatore arriva sulla Dashboard; se per la sua agenzia è spenta, sulla prima
 * voce di lavoro accesa, e in mancanza di tutte sul Profilo (spec voci del menù 2026-10-31). */
const DOPO_LA_DASHBOARD: [VoceMenu, string][] = [
  ["preventivo", "/preventivo-condomini"],
  ["consulenza", "/agenzia/chat"],
  ["pratiche", "/agenzia/pratiche"],
  ["clienti", "/agenzia/clienti"],
];

export function paginaArrivoOperatore(voci: Record<VoceMenu, boolean> | null | undefined): string {
  if (!voci || voci.dashboard) return "/agenzia/dashboard";
  return DOPO_LA_DASHBOARD.find(([v]) => voci[v])?.[1] ?? "/agenzia/profilo";
}
